module.exports = __webpack_public_path__ + "img/2-3.54486916.png";